import { createListSkillsSkill } from './meta/list-skills'
import type { RegisteredSkill, SkillRunResult } from './types'
import { WORD_SKILLS } from './word/word-skills'

// Catalogue of domain skills the agent discovers via list_skills
const ALL_SKILLS: RegisteredSkill[] = [...WORD_SKILLS]

const listSkillsSkill = createListSkillsSkill(() => ALL_SKILLS)

const skillsByName = new Map([...ALL_SKILLS, listSkillsSkill].map((skill) => [skill.name, skill]))

export async function runSkill(
  name: string,
  args: Record<string, unknown>
): Promise<SkillRunResult> {
  const skill = skillsByName.get(name)
  if (!skill) {
    return { ok: false, error: `Unknown skill "${name}"` }
  }

  try {
    return await skill.handler(args)
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
